import React from 'react'
import { DropTarget } from 'components/library'
import './DroppableCard.css'

const DroppableCard = props => {
  return (
    <div className={`Droppable-card ${props.list.length > 0 ? 'is-populated' : ''}`}>
      <DropTarget dropData={props.data}>
        {props.children}

        {props.background &&
          <div className="Draggable-card-background" style={{ backgroundImage: `url(${props.background})` }}></div>
        }

        {props.label &&
          <div className="Draggable-card-label">{props.label}</div>
        }

        <div className="Draggable-card-content">
          {props.list.map((item, idx) => (
            <div className="Draggable-card" key={idx}>{item.label}</div>
          ))}
        </div>
      </DropTarget>
    </div>
  )
}

export default DroppableCard 


// WEBPACK FOOTER //
// ./src/components/library/dnd/DroppableCard.js